import { Routes } from '@angular/router';
import { EventSelectorConst, EventSiteConst } from './common/enums';
import { ngBeerEventsResolver } from './content/content';
import type { PreloadRouteData } from './custom.preloading-strategy';
import { WebsiteLanguage } from './i18n';
import {
  LOCALE_LESS_REDIRECT,
  ROOT_LANGUAGE_REDIRECT,
} from './locale-redirect.routing';

/**
 * The micro-sites are their own entry point: nothing on the site links into
 * them, so idle preloading would buy every visitor a chunk they never open.
 */
const MICRO_SITE_DATA: PreloadRouteData = { preload: false };

export const APP_ROUTES: Routes = [
  {
    path: WebsiteLanguage.English,
    loadChildren: () => import('./site/site.en.routing'),
  },
  {
    path: WebsiteLanguage.Czech,
    loadChildren: () => import('./site/site.cs.routing'),
  },
  {
    path: `${EventSiteConst.NgBeer}/:${EventSelectorConst.City}/:${EventSelectorConst.Volume}`,
    pathMatch: 'full',
    loadComponent: () => import('./micro-sites/ng-beer/ng-beer.component'),
    data: MICRO_SITE_DATA,
    resolve: { events: ngBeerEventsResolver },
  },
  {
    path: `${EventSiteConst.NgBeer}/:${EventSelectorConst.City}`,
    pathMatch: 'full',
    loadComponent: () => import('./micro-sites/ng-beer/ng-beer.component'),
    data: MICRO_SITE_DATA,
    resolve: { events: ngBeerEventsResolver },
  },
  {
    path: EventSiteConst.NgBeer,
    pathMatch: 'full',
    loadComponent: () =>
      import('./micro-sites/ng-beer/ng-beer-archive.component'),
    data: MICRO_SITE_DATA,
    resolve: { events: ngBeerEventsResolver },
  },
  ROOT_LANGUAGE_REDIRECT,
  // Every other locale-less path, known or not, joins the visitor's language;
  // the language branch's wildcard is the 404, with the translations in scope.
  LOCALE_LESS_REDIRECT,
];
